import { render, staticRenderFns } from "./PhotoMaker.vue?vue&type=template&id=771dd8c2&scoped=true&"
import script from "./PhotoMaker.vue?vue&type=script&lang=js&"
export * from "./PhotoMaker.vue?vue&type=script&lang=js&"
import style0 from "./PhotoMaker.vue?vue&type=style&index=0&id=771dd8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771dd8c2",
  null
  
)

export default component.exports